import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Classes from '../../../common/Classes';
import StringFormatter from '../../../common/StringFormatter';
import mixpanelConstants from '../../../common/mixpanelConstants';

const MainStandHolderName = props => (
  <div className={classnames(Classes.mshNameSection)}>
    <span className={Classes.mainStandHolderNamePrefix}>{props.translations.sharedWith}</span>
    <span className={classnames(Classes.mainStandHolderName, Classes.wrapWord, Classes.singleLineEllipsis)} onClick={() => props.triggerMixpanelEvent(mixpanelConstants.element.mainStandHolderTitle)}>
      <a
        href={StringFormatter.format(props.detailPageLinkFormat, props.exhibitor.mainStandHolderOrganisationId)}
        data-dtm={props.tags.mainStandHolderName}
        data-dtm-attributes={JSON.stringify({ exhibitorId: props.exhibitor.parentId })}
      >
        {props.exhibitor.mainStandHolderName}
      </a>
    </span>
  </div>
);

MainStandHolderName.propTypes = {
  detailPageLinkFormat: PropTypes.string.isRequired,
  exhibitor: PropTypes.shape({
    parentId: PropTypes.string.isRequired,
    mainStandHolderName: PropTypes.string.isRequired,
    mainStandHolderOrganisationId: PropTypes.string.isRequired
  }).isRequired,
  tags: PropTypes.shape({
    mainStandHolderName: PropTypes.string.isRequired
  }),
  translations: PropTypes.shape({
    sharedWith: PropTypes.string.isRequired
  }),
  triggerMixpanelEvent: PropTypes.func,
};

export default MainStandHolderName;
